export default __webpack_public_path__ + "fonts/0674.woff2";